import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Box, TextField, Button, Typography, Autocomplete, Avatar } from '@mui/material';
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';
import axios from 'axios';

function Page1SubPageCc() {
  // navigation
  const history = useHistory();
  const location = useLocation();

  // state variable 'university' for university topic, default empty string
  const [academicTopic, setAcademicTopic] = useState('');

  const [joinedTopics, setJoinedTopics] = useState([]);

  const [suggestions, setSuggestions] = useState([]);

  const [topAcademicSubjectPosts, setTopAcademicSubjectPosts] = useState([]);

    useEffect(() => {
    axios.get("/user/top-AcademicSubject-posts")
        .then(res => setTopAcademicSubjectPosts(res.data))
        .catch(err => console.error("Top posts error", err));
    }, []);


    useEffect(() => {
        axios.get("/user/me")
            .then(res => setJoinedTopics(res.data.joinedAcademicSubjects || []));
    }, []);
  
    useEffect(() => {
        if (!academicTopic) {
            setSuggestions([]);
            return;
        }

        const timeout = setTimeout(async () => {
            try {
            const res = await axios.get(
                `/academicSubject/search?q=${encodeURIComponent(academicTopic)}`
            );
            setSuggestions(res.data);
            } catch (err) {
            console.error(err);
            }
        }, 250);

        return () => clearTimeout(timeout);
    }, [academicTopic]);

  // fxn that runs when user clicks 'university'
  const handleSearchOrCreate = async () => {
    // if user did not type anything (empty or spaces), stop early
    if (!academicTopic.trim()) return;

    // send POST request to backend to create university if it doesn't exist already
    await axios.post(`/academicSubjects/${academicTopic}`);

    // after successful creation, navigate to university page
    history.push(`/mainsocial/academia/academicsubjects/${academicTopic}`);
  };

  const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };

    const toggleVote = async (postId) => {
        try {
            const res = await axios.post(`/post/${postId}/upvote`);
            setTopAcademicSubjectPosts(prev =>
                prev.map(p =>
                    p._id === postId
                    ? { ...p, upvotes: res.data.upvotes, voted: res.data.voted }
                    : p
                )
            );
        } catch (err) {
            console.error("Vote error", err);
        }
    };

    const navItems = [
      { label: "Popular Academia", path: "/mainsocial/academia/popular" },
      { label: "University", path: "/mainsocial/academia/university" },
      { label: "Academic Subjects", path: "/mainsocial/academia/academicsubjects" },
    ];

    const getButtonStyles = (path) => {
      const active = location.pathname === path;

      return {
        padding: "6px 12px",
        borderColor: active ? "#1f1f1f" : "#333333",
        color: active ? "#1f1f1f" : "#333333",
        backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
        fontWeight: active ? 600 : 500,
        transition: "all 0.15s ease",
        "&:hover": {
          borderColor: "black",
          color: "black",
          backgroundColor: "rgba(0,0,0,0.12)"
        }
      };
    };
  return (
    <div
            style={{
                padding: '20px',
                backgroundColor: '#FFFDF8',
                minHeight: '100vh',  // ensures it covers the full viewport height
                boxSizing: 'border-box', // ensures padding doesn't affect layout
            }}
        >

            <div style={{ width: '200px' }}></div>

            {/* Centered Buttons */}
            {/*<Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                sx={{
                    mt: 4,
                    mb: 4,
                }}
                    >
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page1/c/subPage1Ca')}
                    >
                        Popular Academia
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page1/c/subPage1Cb')}
                    >
                        University
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page1/c/subPage1Cc')}
                    >
                        Academic Subjects
                    </Button>
             </Box>*/}
             {/* Sticky Navigation */}
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1000,
                  backgroundColor: "#FFFDF8",
                  //borderBottom: "1px solid rgba(0,0,0,0.08)",
                  py: 2
                }}
              >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  gap={2}
                  flexWrap="wrap"
                >
                  {navItems.map((item) => (
                    <Button
                      key={item.path}
                      variant="outlined"
                      sx={getButtonStyles(item.path)}
                      onClick={() => history.push(item.path)}
                    >
                      {item.label}
                    </Button>
                  ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
              </Box>
      {/* input field for typing university name */}
      {/*<TextField
        label="Search Academic Subject" // search for university
        variant="outlined" // outlined syle
        value={academicTopic} // bind input value to university state
        onChange={(e) => setAcademicTopic(e.target.value)} // update university as user types
        fullWidth // input takes full width of container
        />*/}
      {/* button trigger university search */}
      {/*<Button
        sx={{ mt: 2 }} // top margin
        variant="outlined" // filled button style
        onClick={handleSearchOrCreate} // call fxn when clicked
        >
          Go to Academic Subject Page
        </Button>*/}
        <Box display="flex" gap={1} justifyContent="center" alignItems="center">
            {/*<TextField
              label="Search University" // search for university
              variant="outlined" // outlined syle
              value={topicName} // bind input value to university state
              onChange={(e) => setTopicName(e.target.value)} // update university as user types
              //fullWidth // input takes full width of container
              sx={{ width: 360 }}
              onKeyDown={(e) => {
                    if (e.key === "Enter") {
                    e.preventDefault();
                    handleSearchOrCreate();
                    }
                }}
              />*/}
              <Autocomplete
                    freeSolo
                    options={suggestions}
                    inputValue={academicTopic}
                    onInputChange={(e, newValue) => setAcademicTopic(newValue)}
                    onChange={(e, value) => {
                    if (value) {
                        history.push(`/mainsocial/academia/academicsubjects/${value}`);
                    }
                    }}
                    sx={{ width: 360 }}
                    renderOption={(props, option) => (
                        <li {...props}>
                        <strong style={{ marginRight: 1 }}>c/</strong>
                        {option}
                        </li>
                    )}
                    renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Search Academic Subject"
                        variant="outlined"
                        onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            e.preventDefault();
                            handleSearchOrCreate();
                        }
                        }}
                    />
                    )}
                />
            {/* button trigger university search */}
            {/*<Button
              sx={{ mt: 2 }} // top margin
              variant="outlined" // filled button style
              onClick={handleSearchOrCreate} // call fxn when clicked
              >
                Go to University Page
            </Button>*/}
            </Box>
            <Box display="flex" mt={2} justifyContent="center" alignItems="center">
                <Typography variant="subtitle1" fontWeight="bold">
                    Joined Sub-Colloquia Academic Subjects
                    </Typography>
            </Box>
        {/*<Box display="flex" gap={1} justifyContent="center" alignItems="center">
            {joinedTopics.length > 0 && (
                <Box mt={3}>
                    <Box display="flex" gap={1} flexWrap="wrap">
                    {joinedTopics.map(topic => (
                        <Button
                        key={topic}
                        variant="outlined"
                        size="large"
                        sx={{ borderRadius: "20px", textTransform: "none" }}
                        onClick={() => history.push(`/academicSubjects/${topic}`)}
                        >
                        c/{topic}
                        </Button>
                    ))}
                    </Box>
                </Box>
            )}
            </Box>*/}
            <Box display="flex" justifyContent="center">
                {joinedTopics.length > 0 && (
                    <Box
                    mt={3}
                    display="flex"
                    gap={1}
                    flexWrap="wrap"
                    justifyContent="center"   // centers each row
                    maxWidth={900}           
                    >
                    {joinedTopics.map(topic => (
                        <Button
                        key={topic}
                        variant="outlined"
                        size="large"
                        sx={{
                            borderRadius: "20px",
                            textTransform: "none",
                            whiteSpace: "nowrap",
                        }}
                        onClick={() => history.push(`/mainsocial/academia/academicsubjects/${topic}`)}
                        >
                        c/{topic}
                        </Button>
                    ))}
                    </Box>
                )}
            </Box>
            {topAcademicSubjectPosts.map((post, i) => (
                <Box
                    key={i} // react key for list item
                    onClick={() => history.push(`/post/${post._id}/comments`)}
                    border="1px solid #ccc" // light border
                    borderRadius="6px" // rounded corners
                    p={2} // padding inside
                    my={2} // margin top and bottom
                    //position="relative"
                    sx={{ 
                        position: "relative", 
                        maxWidth: 900, // limit width 
                        mx: "auto", // center horizontally
                        my: 2, // vertical spacing between each post
                        cursor: "pointer",
                        "&:hover": {
                            backgroundColor: "#f9f9f9"
                        }
                    }}
                >
                    {/*<Box
                      mb={1}
                      p={1}
                      borderLeft="3px solid #aaa"
                      pl={2}
                      onClick={() => history.push(`/topics/${topic}`)}
                        sx={{ "&:hover": { backgroundColor: "#d9e4f0" } }}
                    >
                        <Typography variant="caption" color="textSecondary">
                             Posted on c/{post.topic}
                        </Typography>
                    </Box>*/}
                    <Typography 
                        variant="overline" 
                        color="primary"
                        onClick={(e) => {
                            e.stopPropagation(); 
                            history.push(`/mainsocial/academia/academicsubjects/${post.topic}`)
                        }}
                        sx={{ "&:hover": { backgroundColor: "#d9e4f0" } }}
                    >
                        {post.topic}
                    </Typography>

                    <Box display="flex" alignItems="flex-start" gap={1}>
                        <Avatar
                        src={post.author?.profileImageUrl || '/default-avatar.jpg'}
                        alt={`${post.author?.first_name || ''} ${post.author?.last_name || ''}`}
                        onClick={(e) => visitProfile(e, post.author?._id)}
                           sx={{ 
                            width: 62, 
                            height: 62,
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor: "#d9e4f0",
                            }, 
                            }}
                        />
                        <Box>
                        <Typography variant="subtitle1" fontWeight="bold"
                        onClick={(e) => visitProfile(e, post.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                        >
                            {post.author?.first_name && post.author?.last_name
                            ? `${post.author.first_name} ${post.author.last_name}`
                            : 'Unknown Name'}
                        </Typography>
                        <Typography variant="body2" color="text.secondary"
                        onClick={(e) => visitProfile(e, post.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                        >
                            @{post.author?.username || 'unknown'}
                        </Typography>
                        
                        <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                            {post.title}
                        </Typography>

                        {/* Post content */}
                        <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                            {post.content}
                        </Typography>

                        {/* Date */}
                        <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ display: "block", mt: 0.5 }}
                        >
                            {`${new Date(post.created_at).toLocaleString()}, ${
                                post.commentCount
                            } ${post.commentCount === 1 ? "reply" : "replies"}`}
                        </Typography>

                        </Box>
                    </Box>

                    {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
                        <Button
                        size="small"
                        variant={post.voted ? "contained" : "outlined"}
                        onClick={(e) => {
                                  e.stopPropagation();  
                                  toggleVote(post._id)}
                                }
                        >
                        ▲ {post.voted ? "Unvote" : "Upvote"}
                        </Button>
                        <Typography variant="body2">{post.upvotes} upvotes</Typography>
                    </Box>*/}
                    <Box mt={2} display="flex" alignItems="center" gap={1}>
                        {post.voted ? (
                            <Box
                               sx={{
                                   position: "relative",
                                   display: "inline-flex",
                                   alignItems: "center",
                                   "&:hover .voted-btn": {
                                       opacity: 0,
                                   },
                                   "&:hover .undo-btn": {
                                       opacity: 1,
                                       pointerEvents: "auto",
                                   },
                               }}
                           >
                                <Button
 					                size="small"
                                    className="voted-btn"
                                    variant="contained"
                                    color="success"
                                    disabled
                                    sx={{
                                       transition: "opacity 0.2s ease",
                                    }}
                                >
                                   Power Voted
                               </Button>
                               <Button
                                    size="small"
                                    className="undo-btn"
                                    variant="contained"
                                    color="error"
                                    sx={{
                                       inset: 0,
                                       position: "absolute",
                                       transition: "opacity 0.2s ease",
                                       opacity: 0,
                                       pointerEvents: "none",
                                   }}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleVote(post._id)
                                   }}
                               >
                                    Undo
                               </Button>
                           </Box>
                        ) : (
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={(e) => {
                                e.stopPropagation();
                                toggleVote(post._id)}
                            }
                            >
                                ▲ Power Vote
                            </Button>
                        )}
                        <Typography variant="body2">{post.upvotes} Power Votes</Typography>
                   </Box>
                </Box>
            ))}
    </div>
  );
}

export default Page1SubPageCc;